import { Component } from '@angular/core';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';

@Component({
  selector: 'app-workflow-droppable-name-field',
  templateUrl: './name.component.html',
  styleUrls: ['../../droppable-field.component.scss']
})
export class WorkflowDroppableNameFieldComponent extends WorkflowBaseDroppedField {}
